import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const findTeaPotExample: TemplateDefinition = {
  mode: "compose",
  slug: "find-tea-pot-example",
  version: 1,
  title: "Personal agent",
  description: "Learn from examples",
  thumbnailUuid: BASE_ASSETS.findTeaPotExample.uuid,
  assets: [BASE_ASSETS.cakeMixerExample, BASE_ASSETS.findTeaPotExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "paragraph",
        value: { type: "text", value: "This is an example of objectCategory1:" },
      },
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.cakeMixerExample.uuid,
              extension: BASE_ASSETS.cakeMixerExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Please bound any instance of objectCategory1 in the following frame:" },
      },
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.findTeaPotExample.uuid,
              extension: BASE_ASSETS.findTeaPotExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
